import chalk from 'chalk';
import isInstalledGlobally from 'is-installed-globally';
import latestVersion from 'latest-version';
import semver from 'semver';
import getToDesktopPackageJson from './getToDesktopPackageJson';

export default () => {
  // Ignore during tests
  if (process.env.AVA_PATH) {
    return;
  }

  const pkg = getToDesktopPackageJson();
  latestVersion(pkg.name).then((latest) => {
    if (semver.gt(latest, pkg.version)) {
      const commandToUpdate = chalk.greenBright(
        `npm install ${
          isInstalledGlobally ? '-g' : '--save-dev'
        } @todesktop/cli`,
      );
      console.warn(
        `Your version of @todesktop/cli is out of date.\nRun ${commandToUpdate} to update to v${latest}.`,
      );
      if (!semver.satisfies(latest, `^${pkg.version}`)) {
        console.error(`CLI is exiting because it is out out of date.`);
        process.exit(1);
      }
    }
  });
};
